module.exports = require('./helpers/bundle-url').getBundleURL('dXr8Y') + "logo-dark.eefe0b7f.svg";